var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25037 6.49999C5.15172 6.50056 5.05392 6.48165 4.96259 6.44434C4.87126 6.40704 4.78819 6.35207 4.71815 6.2826L0.220456 1.78491C0.0793003 1.64375 0 1.45231 0 1.25268C0 1.05306 0.0793003 0.861611 0.220456 0.720456C0.361611 0.5793 0.553059 0.5 0.752682 0.5C0.952306 0.5 1.14375 0.5793 1.28491 0.720456L5.25037 4.69342L9.21584 0.727952C9.35924 0.605145 9.5437 0.540973 9.73236 0.54826C9.92102 0.555547 10.1 0.633757 10.2335 0.767259C10.367 0.900762 10.4452 1.07972 10.4525 1.26838C10.4598 1.45704 10.3956 1.64151 10.2728 1.78491L5.7751 6.2826C5.63548 6.42109 5.44703 6.49916 5.25037 6.49999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.bdcf8a88ce11ba70b7344ea677e3c1a5.svg";
export { ForwardRef as ReactComponent };